export default __webpack_public_path__ + "static/media/house.68b4cd30.svg";